import { render, staticRenderFns } from "./BannerProfile.vue?vue&type=template&id=135ae9ec"
import script from "./BannerProfile.vue?vue&type=script&lang=js"
export * from "./BannerProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports